export default "__VITE_ASSET__2dac719e__"